<template>
  <div>
    <nav class="tabs">
      <ul>
        <li v-for="(example, index) in config.examples" class="pv3 ph4 pointer" :key="{ index }" @click="setSelected(index)" :class="{ active: selectedIndex === index }">
          {{ example.label }}
        </li>
      </ul>
    </nav>
    <div class="content scrollable pa4" ref="container">
      <pre class="db pre" v-html="highlighted"></pre>
    </div>
  </div>
</template>

<script>
import Prism from 'prismjs';
import Languages from './languages';

export default {
  name: 'languageExamples',
  props: {
    lang: String
  },

  data() {
    return {
      selectedIndex: 0,
      highlighted: ''
    };
  },

  mounted() {
    this.setSelected(0);
  },

  watch: {
    lang() {
      this.setSelected(0);
    }
  },

  computed: {
    config() {
      return Languages[this.lang];
    }
  },

  methods: {
    async setSelected(index) {
      this.selectedIndex = index;

      const { grammar, language } = this.config;
      const url = this.config.examples[index].url;
      const response = await fetch(url);

      if (response.ok) {
        const code = await response.text();

        this.$emit('exampleChanged', code);
        this.highlighted = Prism.highlight(code.trim(), grammar, language);
        if (this.$refs?.container?.scrollTo) this.$refs.container.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        console.error(`${url} could not be loaded.`);
        this.highlighted = 'The example could not be loaded.';
      }
    }
  }
};
</script>
